module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "detail-info"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("订单详情")]), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("门店信息")])]), _vm._v(" "), _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.distributor_arr
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "门店编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "门店名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "门店地址"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.province) + _vm._s(scope.row.city) + _vm._s(scope.row.area) + _vm._s(scope.row.address))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "门店联系方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_vm._v(_vm._s(scope.row.mobile))]), _vm._v(" "), (scope.row.telephone != '') ? _c('div', [_vm._v("座机：" + _vm._s(scope.row.telephone))]) : _vm._e()]
      }
    }])
  })], 1)], 1)]), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("订单基本信息")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单号：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.order_id) + " ")]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单类型：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.orderInfo.order_type == 'normal') ? _c('span', [_vm._v(" 实体订单 ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_type == 'service') ? _c('span', [_vm._v(" 服务类订单 ")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_type == 'bargain') ? _c('span', [_vm._v(" 助力订单 ")]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单状态：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.orderInfo.order_class == 'drug') ? _c('span', [(_vm.orderInfo.order_status == 'CANCEL') ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v("已取消")]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_status != 'CANCEL') ? [(_vm.orderInfo.ziti_status == 'APPROVE') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("审核通过")]) : _c('el-tag', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("待审核")])] : _vm._e()], 2) : (_vm.orderInfo.order_type == 'bargain') ? _c('span', [(_vm.orderInfo.order_status == 'NOTPAY') ? _c('el-tag', {
    attrs: {
      "type": "primary",
      "size": "mini"
    }
  }, [_vm._v("未支付")]) : (_vm.orderInfo.order_status == 'PAYED') ? _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "mini"
    }
  }, [_vm._v("已支付")]) : _vm._e()], 1) : _c('el-tag', [_vm._v(_vm._s(_vm.orderInfo.order_status_msg))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("第三方来源：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.source) + " ")]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("文章名称：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.docname) + " ")])], 1), _vm._v(" "), (_vm.memberInfo) ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("会员姓名：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(" " + _vm._s(_vm.memberInfo.username))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("会员手机：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(" " + _vm._s(_vm.memberInfo.mobile) + " ")]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("会员等级：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.memberInfo.gradeInfo ? _vm.memberInfo.gradeInfo.grade_name : "无"))])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("商品金额：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.order_type != 'bargain' ? _vm.orderInfo.item_fee / 100 : _vm.orderInfo.item_price / 100)), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("(商品会员扣后价)")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("会员折扣：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("- " + _vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.member_discount / 100))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("货币：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fee_type))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("运费：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.freight_fee / 100))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("优惠券减免：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("- " + _vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.coupon_discount / 100))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("货币汇率：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fee_rate))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("优惠总金额：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("-" + _vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.discount_fee ? _vm.orderInfo.discount_fee / 100 : 0)), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v("(包含优惠券，满折，满减等优惠金额)")])]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("商家优惠券减免：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("- " + _vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.merchant_coupon_discount / 100))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("下单时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.orderInfo.create_time, 'yyyy-MM-dd hh:mm:ss')))])], 1), _vm._v(" "), _c('el-row', [(_vm.tradeInfo.payType != 'point') ? _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单总金额：")])]) : _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单总积分：")])]), _vm._v(" "), (_vm.tradeInfo.payType != 'point') ? _c('el-col', {
    attrs: {
      "span": _vm.tradeInfo.payType != 'point' ? 13 : 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.fee_symbol) + _vm._s(_vm.orderInfo.total_fee / 100))]) : _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.point))]), _vm._v(" "), (_vm.orderInfo.delivery_time != null) ? _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("下账时间：")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.delivery_time != null) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.orderInfo.delivery_time, 'yyyy-MM-dd hh:mm:ss')))]) : _vm._e()], 1), _vm._v(" "), (_vm.orderInfo.order_type == 'service') ? _c('el-row', [(_vm.orderInfo.store_name) ? _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("店铺名称：")])]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.store_name))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单来源：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [(_vm.orderInfo.order_source == 'member') ? _c('span', [_vm._v("自主下单")]) : (_vm.orderInfo.order_source == 'shop') ? _c('span', [_vm._v("代客下单")]) : _vm._e()]), _vm._v(" "), (_vm.orderInfo.order_type == 'service' && _vm.orderInfo.operator_desc != '') ? _c('div', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("操作员：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(" " + _vm._s(_vm.orderInfo.operator_desc) + " ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfo.remark) ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("订单备注：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.remark))])], 1) : _vm._e(), _vm._v(" "), (_vm.cancelData && _vm.orderInfo.order_status == 'CANCEL' && _vm.orderInfo.cancel_status == 'NO_APPLY_CANCEL') ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("取消原因：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("未支付自动取消")])], 1) : _vm._e(), _vm._v(" "), (_vm.cancelData && _vm.orderInfo.order_status == 'CANCEL' && _vm.orderInfo.cancel_status == 'SUCCESS') ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("取消原因：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("卖家申请退款")])], 1) : _vm._e(), _vm._v(" "), (_vm.cancelData && _vm.cancelData.cancel_from == 'buyer' && _vm.cancelData.cancel_reason) ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("申请取消原因：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.cancelData.cancel_reason) + " "), _c('span', {
    staticClass: "sp_time"
  }, [_vm._v("|")]), _vm._v(" 取消时间：" + _vm._s(_vm._f("datetime")(_vm.cancelData.create_time, 'yyyy-MM-dd hh:mm:ss')))])], 1) : _vm._e(), _vm._v(" "), (_vm.cancelData && _vm.cancelData.cancel_from == 'shop' && _vm.cancelData.cancel_reason) ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("商家取消原因：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.cancelData.cancel_reason) + " "), _c('span', {
    staticClass: "sp_time"
  }, [_vm._v("|")]), _vm._v(" 取消时间：" + _vm._s(_vm._f("datetime")(_vm.cancelData.create_time, 'yyyy-MM-dd hh:mm:ss')))])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.orderInfo.discount_info && _vm.orderInfo.discount_info.length > 0) ? _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("优惠明细")])]), _vm._v(" "), _vm._l((_vm.orderInfo.discount_info), function(item, index) {
    return (item.type != 'full_gift') ? _c('el-row', {
      key: index
    }, [_c('el-col', {
      staticClass: "content-right",
      attrs: {
        "span": 3
      }
    }, [_c('h4', [_vm._v(_vm._s(item.type === 'full_discount' ? '满折优惠：' : ''))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.type === 'full_minus' ? '满减优惠：' : ''))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(item.type === 'coupon_discount' ? '优惠券优惠：' : ''))])]), _vm._v(" "), (item.discount_fee > 0) ? _c('el-col', {
      attrs: {
        "span": 20
      }
    }, [_vm._v("\n          " + _vm._s(item.merchant_iscost == 0 ? '平台' : '商家') + "\n          优惠" + _vm._s(_vm.orderInfo.fee_symbol) + _vm._s(item.discount_fee / 100) + "   \n          "), _c('span', {
      staticClass: "frm-tips"
    }, [_vm._v(_vm._s(item.title) + "(" + _vm._s(item.rule) + ")")])]) : _vm._e()], 1) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("支付信息")])]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tradeIf
    }
  }, [_c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "交易单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.tradeId))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "支付状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.tradeState == 'SUCCESS') ? _c('span', [_vm._v(" 支付成功")]) : (scope.row.tradeState == 'REFUND') ? _c('span', [_vm._v("转入退款")]) : (scope.row.tradeState == 'CANCEL_CLOSED') ? _c('span', [_vm._v("已取消")]) : (scope.row.tradeState == 'REFUND_SUCCESS') ? _c('span', [_vm._v("退款成功")]) : (scope.row.tradeState == 'NOTPAY') ? _c('span', [_vm._v("未支付")]) : _vm._e(), _vm._v(" "), (scope.row.tradeState == 'CLOSED') ? _c('span', [_vm._v(" 已关闭")]) : (scope.row.tradeState == 'REVOKED') ? _c('span', [_vm._v("已撤销")]) : (scope.row.tradeState == 'PAYERROR') ? _c('span', [_vm._v("支付失败(其他原因，如银行返回失败)")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "交易流水号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.transactionId))])]
      }
    }])
  }), _vm._v(" "), (_vm.tradeIf.payType != 'point') ? [_c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "支付金额(RMB)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payFee / 100))])]
      }
    }], null, false, 3039591990)
  })] : _vm._e(), _vm._v(" "), (_vm.tradeIf.payType == 'point') ? [_c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "支付积分"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.payFee))])]
      }
    }], null, false, 1464439496)
  })] : _vm._e(), _vm._v(" "), _c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "支付类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.payType == 'amorepay') ? _c('span', [_vm._v(" 微信支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'wxpaypc') ? _c('span', [_vm._v(" 微信PC支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'wxpay') ? _c('span', [_vm._v(" 微信支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'wxpayapp') ? _c('span', [_vm._v(" 微信APP支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'wxpayh5') ? _c('span', [_vm._v(" 微信H5支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'alipay') ? _c('span', [_vm._v(" 支付宝支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'alipayapp') ? _c('span', [_vm._v(" 支付宝APP支付")]) : _vm._e(), _vm._v(" "), (scope.row.payType == 'alipayh5') ? _c('span', [_vm._v(" 支付宝H5支付")]) : (scope.row.payType == 'alipayxapp') ? _c('span', [_vm._v(" 支付宝小程序支付")]) : (scope.row.payType == 'deposit') ? _c('span', [_vm._v(" 余额支付")]) : (scope.row.payType == 'yaoking_deposit') ? _c('span', [_vm._v(" 商城预存款")]) : (scope.row.payType == 'point') ? _c('span', [_vm._v(" 积分支付")]) : (scope.row.payType == 'pos') ? _c('span', [_vm._v(" POS银行卡支付")]) : (scope.row.payType == 'yibaopay') ? _c('span', [_vm._v(" 省医保支付")]) : (scope.row.payType == 'jh_digital') ? _c('span', [_vm._v(" 交行数字快捷支付")]) : (scope.row.payType == 'spdb_h5_xppay') ? _c('span', [_vm._v(" 浦发小浦支付")]) : (scope.row.payType == 'ccb_h5_digital') ? _c('span', [_vm._v(" 建行数字货币支付")]) : (scope.row.payType == 'SCAN_ALIPAY') ? _c('span', [_vm._v(" 商家支付宝支付")]) : (scope.row.payType == 'WECHATPAY_MINIPROGRAM') ? _c('span', [_vm._v(" 商家微信小程序支付")]) : (scope.row.payType == 'peihepay') ? _c('span', [_vm._v(" 沛合直付")]) : (scope.row.payType == 'benefit') ? _c('span', [_vm._v(" 优卡支付")]) : (scope.row.payType == 'fuioupay_miniprogram') ? _c('span', [_vm._v(" 富友微信小程序支付")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "交易时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.timeStart, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "交易结束时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (scope.row.timeExpire != null) ? [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.timeExpire, 'yyyy-MM-dd hh:mm:ss')))])] : undefined
      }
    }], null, true)
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "content-right",
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.tradeState == 'NOTPAY' && (scope.row.payType == 'WECHATPAY_MINIPROGRAM' || scope.row.payType == 'SCAN_ALIPAY')) ? _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.getPayStatus(scope.row.tradeId)
            }
          }
        }, [_vm._v("查询交易状态")]) : _vm._e()]
      }
    }])
  })], 2)], 1)]), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("商品清单")])]), _vm._v(" "), (_vm.orderInfo.order_type == 'service' || _vm.orderInfo.order_type == 'bargain') ? _c('div', [_c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("商品名称：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.title))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_vm._v("商品数量：")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.item_num))])], 1)], 1) : (_vm.orderInfo.order_type == 'normal') ? _c('div', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderInfo.items
    }
  }, [_c('el-table-column', {
    staticClass: "goods-img",
    attrs: {
      "prop": "pic",
      "label": "商品图片",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_c('img', {
          staticClass: "item-image",
          attrs: {
            "src": _vm.wximageurl + scope.row.pic,
            "alt": scope.row.item_name
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "label": "商品名称",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.item_name)), (scope.row.order_item_type == 'gift') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "type": "success"
          }
        }, [_vm._v("赠品")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_spec_desc",
      "label": "货号",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.item_bn) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_spec_desc",
      "label": "规格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.item_spec_desc ? scope.row.item_spec_desc : '单规格') + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "数量",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总价(元)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货币"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.fee_type))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货币汇率"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.fee_rate))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "服务费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.is_settle_in_service_price))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "总服务费"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.is_settle_in_service_total_price))])]
      }
    }])
  }), _vm._v(" "), (_vm.orderInfo.delivery_status == 'DONE' && !_vm.orderInfo.delivery_corp) ? [_c('el-table-column', {
    attrs: {
      "label": "发货状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v("已发货")])]
      }
    }], null, false, 1882035535)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "快递公司"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.orderInfo.order_status == 'WAIT_BUYER_CONFIRM') ? _c('span', [_c('el-select', {
          attrs: {
            "filterable": "",
            "placeholder": "请选择快递公司，可搜索"
          },
          model: {
            value: (scope.row.delivery_corp),
            callback: function($$v) {
              _vm.$set(scope.row, "delivery_corp", $$v)
            },
            expression: "scope.row.delivery_corp"
          }
        }, _vm._l((_vm.dlycorps), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.name,
              "value": item.value
            }
          })
        }), 1)], 1) : _c('span', [_vm._v(_vm._s(scope.row.delivery_corp_name))])]
      }
    }], null, false, 3877730050)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "快递单号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.orderInfo.order_status == 'WAIT_BUYER_CONFIRM') ? _c('span', [_c('el-input', {
          attrs: {
            "maxlength": 20,
            "placeholder": "物流公司单号"
          },
          model: {
            value: (scope.row.delivery_code),
            callback: function($$v) {
              _vm.$set(scope.row, "delivery_code", $$v)
            },
            expression: "scope.row.delivery_code"
          }
        })], 1) : _c('span', [_vm._v(_vm._s(scope.row.delivery_code))])]
      }
    }], null, false, 2917536789)
  })] : _vm._e()], 2)], 1) : _vm._e()]), _vm._v(" "), (_vm.orderInfo.order_class == 'drug') ? _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("用药人信息")])]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("用药人身份证：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.third_params.drug_buyer_id_card ? _vm.orderInfo.third_params.drug_buyer_id_card : '未填写身份证信息'))]), _vm._v(" "), (_vm.orderInfo.ziti_status != 'APPROVE' && _vm.orderInfo.order_status != 'CANCEL') ? _c('div', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("审核处理：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "true"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "false"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_vm._v("审核拒绝")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("用药人姓名：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.third_params.drug_buyer_name ? _vm.orderInfo.third_params.drug_buyer_name : '未填写用药人姓名'))]), _vm._v(" "), (_vm.orderInfo.ziti_status != 'APPROVE' && _vm.orderInfo.order_status != 'CANCEL') ? _c('div', [(_vm.form.status == 'false') ? _c('div', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("拒绝原因：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入审核拒绝原因"
    },
    model: {
      value: (_vm.form.reject_reason),
      callback: function($$v) {
        _vm.$set(_vm.form, "reject_reason", $$v)
      },
      expression: "form.reject_reason"
    }
  })], 1)], 1) : _c('div', [(_vm.orderInfo.ziti_status != 'APPROVE' && _vm.orderInfo.order_status != 'CANCEL' && _vm.form.receipt_type == 'ziti' && _vm.form.status == 'true') ? _c('div', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("自提门店：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "placeholder": "门店名称关键字",
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.form.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_id", $$v)
      },
      expression: "form.shop_id"
    }
  }, _vm._l((_vm.shopsList), function(item) {
    return _c('el-option', {
      key: item.wxShopId,
      attrs: {
        "label": item.storeName,
        "value": item.wxShopId
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(item.storeName))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(item.address))])])
  }), 1)], 1)], 1) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("纸质处方单：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, _vm._l((_vm.orderInfo.third_params.drug_list_image), function(item, index) {
    return _c('span', [_c('img', {
      staticClass: "item-image",
      attrs: {
        "src": item.url
      },
      on: {
        "click": function($event) {
          return _vm.imagedetail(item.url)
        }
      }
    })])
  }), 0)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_vm._v("   ")]), _vm._v(" "), (_vm.orderInfo.ziti_status != 'APPROVE' && _vm.orderInfo.order_status != 'CANCEL') ? _c('div', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.process
    }
  }, [_vm._v("提交审核")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.orderInfo.order_class == 'drug') ? _c('el-dialog', {
    attrs: {
      "title": "纸质处方单",
      "visible": _vm.dialogVisible,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.bigImageUrl) ? _c('img', {
    staticStyle: {
      "width": "100%",
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.bigImageUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.receipt_type || _vm.orderInfo.order_type == 'bargain') ? _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("物流信息")])]), _vm._v(" "), _c('el-row', [(_vm.orderInfo.receipt_type == 'ziti') ? _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("自提地址：")])]) : _vm._e(), _vm._v(" "), (_vm.orderInfo.receipt_type == 'ziti') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v("\n          " + _vm._s(_vm.distributor.store_name) + " "), _c('span', {
    staticClass: "frm-tips"
  }, [_vm._v(_vm._s(_vm.distributor.store_address))])]) : _vm._e()], 1), _vm._v(" "), _c('el-row', [(_vm.orderInfo.receiver_address) ? _c('div', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("收货人信息：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.receiver_name) + " , " + _vm._s(_vm.orderInfo.receiver_mobile) + " , " + _vm._s(_vm.orderInfo.receiver_state) + _vm._s(_vm.orderInfo.receiver_city) + _vm._s(_vm.orderInfo.receiver_district) + _vm._s(_vm.orderInfo.receiver_address) + " ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.orderInfo.delivery_status == 'DONE' && _vm.orderInfo.delivery_code) ? _c('el-row', [_c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("快递公司：")])]), _vm._v(" "), (_vm.orderInfo.order_status == 'WAIT_BUYER_CONFIRM') ? _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择快递公司，可搜索"
    },
    model: {
      value: (_vm.orderInfo.delivery_corp),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "delivery_corp", $$v)
      },
      expression: "orderInfo.delivery_corp"
    }
  }, _vm._l((_vm.dlycorps), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1) : _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_vm._v("\n          " + _vm._s(_vm.dlycorpskn[_vm.orderInfo.delivery_corp]) + "\n          "), (!_vm.orderInfo.delivery_corp == 'OTHER') ? _c('el-button', {
    attrs: {
      "type": "success",
      "size": "mini"
    },
    on: {
      "click": _vm.deliveryDesc
    }
  }, [_vm._v("查看物流详情")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("快递单号：")])]), _vm._v(" "), (_vm.orderInfo.order_status == 'WAIT_BUYER_CONFIRM') ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 20,
      "placeholder": "物流公司单号"
    },
    model: {
      value: (_vm.orderInfo.delivery_code),
      callback: function($$v) {
        _vm.$set(_vm.orderInfo, "delivery_code", $$v)
      },
      expression: "orderInfo.delivery_code"
    }
  })], 1) : _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm.orderInfo.delivery_code))]), _vm._v(" "), _c('el-col', {
    staticClass: "content-right",
    attrs: {
      "span": 3
    }
  }, [_c('h4', [_vm._v("发货时间：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v(_vm._s(_vm._f("datetime")(_vm.orderInfo.delivery_time, 'yyyy-MM-dd hh:mm:ss')))])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "content-center"
  }, [(_vm.orderInfo.order_status == 'WAIT_BUYER_CONFIRM') ? _c('el-button', {
    on: {
      "click": _vm.updateDeliveryAction
    }
  }, [_vm._v("修改物流信息")]) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "物流详情",
      "visible": _vm.dialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    }
  }, [(this.activities.length > 0) ? _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "radio"
  }, [_vm._v("\n          排序：\n          "), _c('el-radio-group', {
    model: {
      value: (_vm.reverse),
      callback: function($$v) {
        _vm.reverse = $$v
      },
      expression: "reverse"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": true
    }
  }, [_vm._v("正序")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": false
    }
  }, [_vm._v("倒序")])], 1)], 1), _vm._v(" "), _c('el-timeline', {
    attrs: {
      "reverse": _vm.reverse
    }
  }, _vm._l((_vm.activities), function(activity, index) {
    return _c('el-timeline-item', {
      key: index,
      attrs: {
        "timestamp": activity.AcceptTime
      }
    }, [_vm._v("\n            " + _vm._s(activity.AcceptStation) + "\n          ")])
  }), 1)], 1) : _c('div', {
    staticClass: "block"
  }, [_vm._v("暂无信息")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("关  闭")])], 1)]), _vm._v(" "), _c('el-card', {
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', [_vm._v("备注：")])]), _vm._v(" "), _c('el-row', [_c('div', [_vm._v("\n          客户备注： " + _vm._s(_vm.orderInfo.remark) + "\n        ")]), _vm._v(" "), (_vm.orderInfo.receiver_address) ? _c('div', [_vm._v("\n          管理员备注： " + _vm._s(_vm.orderInfo.admin_remarks) + "\n        ")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer content-padded content-center with-border"
  }, [_c('el-button', {
    on: {
      "click": _vm.retrunClick
    }
  }, [_vm._v("返回")])], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-27aceaf5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27aceaf5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/order/detail.vue
// module id = 2554
// module chunks = 0